import React from "react";

const FooterAction = () => {
  return <div>FooterAction</div>;
};

export default FooterAction;
